import React from 'react';
import PropTypes from 'prop-types';

const Pan = ({ fill, ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M 10.5 6 L 4.5 6 L 4.5 7.5 L 10.5 7.5 Z M 10.5 6 "
      fill={fill || '#6B6C7B'}
    />
    <path
      d="M 10.5 10.5 L 4.5 10.5 L 4.5 12 L 10.5 12 Z M 10.5 10.5 "
      fill={fill || '#6B6C7B'}
    />
    <path
      d="M 21.601562 0 L 2.398438 0 C 1.078125 0 0 1.078125 0 2.398438 L 0 15.601562 C 0 16.921875 1.078125 18 2.398438 18 L 21.601562 18 C 22.921875 18 24 16.921875 24 15.601562 L 24 2.398438 C 24 1.078125 22.921875 0 21.601562 0 Z M 21.601562 15.601562 L 2.398438 15.601562 L 2.398438 2.398438 L 21.601562 2.398438 Z M 21.601562 15.601562 "
      fill={fill || '#6B6C7B'}
    />
    <path
      d="M 15.601562 9 C 16.59375 9 17.398438 8.195312 17.398438 7.199219 C 17.398438 6.207031 16.59375 5.398438 15.601562 5.398438 C 14.605469 5.398438 13.800781 6.207031 13.800781 7.199219 C 13.800781 8.195312 14.605469 9 15.601562 9 Z M 15.601562 9 "
      fill={fill || '#6B6C7B'}
    />
    <path
      d="M 18.121094 10.4375 C 17.398438 10.078125 16.558594 9.957031 15.601562 9.957031 C 14.640625 9.957031 13.921875 10.199219 13.078125 10.4375 C 12.480469 10.679688 12 11.398438 12 12.117188 L 12 12.597656 L 19.199219 12.597656 L 19.199219 12.117188 C 19.199219 11.398438 18.71875 10.679688 18.121094 10.4375 Z M 18.121094 10.4375 "
      fill={fill || '#6B6C7B'}
    />
  </svg>
);

Pan.propTypes = {
  fill: PropTypes.string,
};

export default Pan;
